import { ICustomerDetails } from "@interface/customerDetails/ICustomerDetails";

interface IAddressPayload {
    postalCode: string;
    city: string;
    area: string;
    street: string;
    buildingName: string;
    buildingType: string;
    streetQualifier: string;
    streetNumber: string;
    postalBox: string;
    enablePostalBox: boolean;
    flatNumber: string;
}

interface IPersonPayload {
    birthDate: string;
    firstName: string;
    lastName: string;
    identificationNumber: string;
}

interface IOwnerPayload {
    email: string;
    mobileNumber?: string;
    countryCode?: string;
    person: IPersonPayload;
    communicationLanguage: string;
    privacyPolicy: boolean;
    precontractualTerms: boolean;
    permissions: boolean;
}

export interface ICustomerDetailsPayload {
    billingAddress: IAddressPayload;
    //contactPermission: IContactPermissionPayload;
    owner: IOwnerPayload;
}

export const getStateToPayload = (customerDetails: ICustomerDetails): ICustomerDetailsPayload => ({
    billingAddress: {
        postalCode: customerDetails.billingAddress.postalCode,
        city: customerDetails.billingAddress.city,
        area: customerDetails.billingAddress.area,
        street: customerDetails.billingAddress.street,
        buildingName: customerDetails.billingAddress.buildingName,
        buildingType: customerDetails.billingAddress.buildingType,
        streetQualifier: customerDetails.billingAddress.streetQualifier,
        streetNumber: customerDetails.billingAddress.streetNumber,
        postalBox: customerDetails.billingAddress.postalBox,
        enablePostalBox: customerDetails.billingAddress.enablePostalBox,
        flatNumber: customerDetails.billingAddress.flatNumber,
    },
    owner: {
        email: customerDetails.owner.email,
        mobileNumber: customerDetails.owner.mobileNumber,
        countryCode: customerDetails.owner.countryCode,
        communicationLanguage: customerDetails.owner.communicationLanguage,
        privacyPolicy: customerDetails.owner.privacyPolicy,
        precontractualTerms: customerDetails.owner.precontractualTerms,
        permissions: customerDetails.owner.permissions,
        person: {
            identificationNumber: customerDetails.owner.person.identificationNumber,
            birthDate: customerDetails.owner.person.birthDate,
            firstName: customerDetails.owner.person.firstName,
            lastName: customerDetails.owner.person.lastName,
        },
    },
});


